import type { ApiRequest } from '@/types/api';
import type { FeatureFlag } from '@/types/models';

export type ListFeatureFlagsRequest = ApiRequest<
    'GET',
    'feature-flags',
    {
        data: {
            features: Record<FeatureFlag, boolean>;
        };
    }
>;

type FeatureFlagsApi = {
    list: ListFeatureFlagsRequest['url'];
};

export const featureFlagsApi: FeatureFlagsApi = {
    list: 'feature-flags',
};
